"use strict";

angular.module('app.purchase', [])
    .config([
        '$stateProvider',
        function ($stateProvider) {
            $stateProvider.state(
                'app.purchase',
                {
                    abstract: true,
                    template: '<ui-view></ui-view>'
                }
            )
        }
    ]);


// WEBPACK FOOTER //
// ./app.v2/components/purchase/purchase.js